// Afixos de raridade (documento de design): raro 1 afixo de 0,5 a 1%, épico 2 de 1 a 1,5%, lendário 3 de 1,5 a 2%.
// A lista de afixos por tipo de item e os tetos globais ainda estão em aberto no design: valores abaixo são proposta.
import type { EquipSlot, Rarity } from './items.js';

export type AffixKey =
  | 'dmg' | 'crit' | 'critdmg' | 'lifeleech' | 'manaleech'
  | 'hp' | 'mana' | 'speed'
  | 'res_physical' | 'res_fire' | 'res_ice' | 'res_energy' | 'res_earth' | 'res_death' | 'res_holy';

export interface Affix { k: AffixKey; v: number }

export const AFFIX_NAMES: Record<AffixKey, string> = {
  dmg: 'dano', crit: 'chance de crítico', critdmg: 'dano crítico', lifeleech: 'roubo de vida', manaleech: 'roubo de mana',
  hp: 'vida máxima', mana: 'mana máxima', speed: 'velocidade',
  res_physical: 'proteção física', res_fire: 'proteção contra fogo', res_ice: 'proteção contra gelo', res_energy: 'proteção contra energia',
  res_earth: 'proteção contra terra', res_death: 'proteção contra morte', res_holy: 'proteção sagrada',
};

const RES: AffixKey[] = ['res_physical', 'res_fire', 'res_ice', 'res_energy', 'res_earth', 'res_death', 'res_holy'];
/** Lista de afixos possíveis por tipo de item. */
export const AFFIX_POOL: Partial<Record<EquipSlot, AffixKey[]>> = {
  weapon: ['dmg', 'crit', 'critdmg', 'lifeleech', 'manaleech'],
  ammo: ['dmg', 'crit', 'critdmg'],
  shield: ['hp', 'mana', ...RES],
  head: ['hp', 'mana', 'manaleech', ...RES],
  armor: ['hp', 'mana', ...RES],
  legs: ['hp', 'mana', ...RES],
  feet: ['hp', 'speed', ...RES],
  neck: ['hp', 'mana', 'crit', 'lifeleech', 'manaleech', ...RES],
  ring: ['hp', 'mana', 'crit', 'critdmg', 'lifeleech', 'manaleech'],
};

/** Teto global de cada atributo somando todo o equipamento (proposta: 20%). */
export const AFFIX_CAP = 20;

const RANGE: Record<1 | 2 | 3, [number, number]> = { 1: [0.5, 1], 2: [1, 1.5], 3: [1.5, 2] };

export function rollAffixes(slot: EquipSlot | undefined, rarity: Rarity, rnd = Math.random): Affix[] {
  if (!rarity || !slot) return [];
  const pool = [...(AFFIX_POOL[slot] ?? [])];
  const out: Affix[] = [];
  const [lo, hi] = RANGE[rarity as 1 | 2 | 3];
  for (let i = 0; i < rarity && pool.length; i++) {
    const k = pool.splice(Math.floor(rnd() * pool.length), 1)[0]!;
    out.push({ k, v: Math.round((lo + rnd() * (hi - lo)) * 10) / 10 });
  }
  return out;
}

/** Soma dos afixos do equipamento, já limitada pelo teto. */
export function affixTotals(list: Affix[][]): Partial<Record<AffixKey, number>> {
  const t: Partial<Record<AffixKey, number>> = {};
  for (const a of list.flat()) t[a.k] = Math.min(AFFIX_CAP, Math.round(((t[a.k] ?? 0) + a.v) * 10) / 10);
  return t;
}

export function describeAffix(a: Affix) { return `+${String(a.v).replace('.', ',')}% ${AFFIX_NAMES[a.k]}`; }
